var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-button",on:{"click":_vm.deleteSelected}},[_c('SvgIcon',{staticClass:"delete-icon",attrs:{"icon":_vm.icons.SvgDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }